export default "__VITE_ASSET__be88deec__"